export class LiveCard {
    id: string;
    drawingPointId: string;
    accountId: string;
    drawingPointNumber: string;
    accountNumber: string;
    vrn: string;
    driverName: string;
    purchaseCode: string;
    cardNumber: string;
    pin: string;
    expiryDate: Date;
    lastUsedDate: Date;
    issueDate: Date;
    CostCentre: string;
    DriverDescription: string;
    DateEffective: Date;
}

export class LiveCardModel {
    EndPointURL: string;
    Token: string;
    AccountNumbers: string[]
    AccountEndPointURL: string;
    UserId: string;
    CostCentreModel: CostCentreModel;
}

export class LiveStopCardModel {
    EndPointURL: string;
    Token: string;
    AccountNumbers: string[]
    AccountEndPointURL: string;
    PendingStopEndPointURL: string;
    UserId: string;
}

export class CostCentre {
    id: string;
    name: string;
    driver: string;
    effectiveDate: string;
    effectiveDateDate: Date;
    UserId: string;

}

export class CostCentreModel {
    CostCentre: CostCentre;
    EndPointURL: string;
    Token: string;
    CardId: string;
    UserId: string;
    AccountNumbers: string[];
    CostCenterUrl: string;
    CostCentreId: string;
}

export class CardDetail {
    id: string;
    drawingPointNumber: string;
    accountNumber: string;
    registration: string;
    cardNumber: string;
    purchaseCode: string;
    shortCardNumber: string;
    expiryDate: Date;
    lastUsedDate?: any;
    issueDate: Date;
    accountManagerName: string;
    nameOnCard: string;
}

export class CardDetailModel {
    EndPointURL: string;
    Token: string;
    CardId: string;
}

export class CardDrawing {
    id: string;
    drawnDate: Date;
    drawnTime: string;
    accountNumber: string;
    cardNumber: string;
    shortCardNumber: string;
    driverName: string;
    registration: string;
    vrnSite: string;
    odometer: number;
    siteName: string;
    sitePostCode: string;
    product: string;
    invoiceNumber: string;
    quantity: number;
    price: number;
    estimatedPrice: number;
    companyName: string;
    costCenter: string;
    driverDescription: string;
    invoiceDate: Date;
    transactionNumber: string;
    ledgerName: string;
    ledgerNumber: string;
    isBunkered: boolean;
    ghg: number;
    cO2: number;
    n2O: number;
    cH4: number;
}

export class CardDrawingModel {
    EndPointURL: string;
    Token: string;
    CardId: string;
}

export class PendingStopCard {
    id: string;
    drawingPointNumber: string;
    accountNumber: string;
    vrn: string;
    driverName: string;
    purchaseCode: string;
    cardNumber: string;
}

export class PendingStopCardModel {
    EndPointURL: string;
    Token: string;
    AccountNumbers: string[];
}

export class ReduntantCard {
    id: string;
    drawingPointNumber: string;
    accountNumber: string;
    vrn: string;
    driverName: string;
    purchaseCode: string;
    cardNumber: string;
    deadReason: string;
    issueDate: Date;
    cardDeadDate: Date;
}

export class ReduntantCardModel {
    EndPointURL: string;
    Token: string;
    AccountNumbers: string[];
    UserId: string;
}


export class AddCardModel {
    product: string;
    drawingPointId: string;
    purchaseOption: string;
    orderType: string;
    embossType: string;
    embossValue: string;
    pin: number;
}

export class CardDrawingEndPoint {
    id: string;
    accountId: string;
    number: string;
    name: string;
    defaultPinNumber: string;
    defaultPurchaseOption: string;
    isDefaultDrawingPoint: boolean;
}

export class DrawingPointModel {
    EndPointURL: string;
    Token: string;
    AccountId: string;
}

export class PurchaseOption {
    name: string;
}

export class PurchaseOptionModel {
    EndPointURL: string;
    Token: string;
}

export class CardAddress {
    id: number;
    companyId: string;
    address1: string;
    address2: string;
    address3: string;
    postCode: string;
    postToName: string;
}

export class CardAddressModel {
    CardAddress: CardAddress;
    EndPointURL: string;
    Token: string;
    CompanyId: string;
    cardAddressId: string;
}

export class TempCard {
    product: string;
    productText: string;
    drawPointText: string;
    orderTypeText: string;

    drawingPointId: string;
    purchaseOption: string;
    embossType: string;
    embossValue: string;
    pin: string;
    note: string;
    orderType: string;
    cardAddress1: string;
    cardAddress2: string;
    cardAddress3: string;
    cardAddressPostCode: string;
    cardAddressPostToName: string;
}

export class CreateCard {
    drawingPointId: string;
    purchaseOption: string;
    embossType: string;
    embossValue: string;
    pin: string;
    note: string;
    orderType: string;
    cardAddress1: string;
    cardAddress2: string;
    cardAddress3: string;
    cardAddressPostCode: string;
    cardAddressPostToName: string;
}

export class CreateCardModel {
    cardRequests: CreateCard[];
}

export class CreateCardPassModel {
    CreateCards: CreateCardModel;
    EndPointURL: string;
    Token: string;
    CompanyId: string;
}

export class StopCard {
    cardId: string;
    cardNumber: string;
    reason: string;
    requiresReplacement: boolean;
}

export class StopCardModel {
    stopRequests: StopCard[];
}

export class StopCardPassModel {
    StopCards: StopCardModel;
    EndPointURL: string;
    Token: string;
    CompanyId: string;
}

export class CardHistoryModel {
    EndPointURL: string;
    Token: string;
}

export class CardHistory {
    id: string;
    requestDate: Date;
    requestedBy: string;
    requestType: string;
    numberOfCards: number;
    status: string;
}

export class CardRequest {
    id: string;
    drawingPointNumber: string;
    accountNumber: string;
    vrn: string;
    driverName: string;
    purchaseCode: string;
    shortCardNumber: string;
    lostOrStolen: string;
    replacementOrdered: boolean;
    isAdditionalCard: boolean;
    requestNotes?: any;
}

export class CardRequestModel {
    RequestId: string;
    EndPointURL: string;
    Token: string;
}

export class LiveCardsDataTablesResponse {
    data: LiveCard[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
    referenceNumber: string;
    error: string;
}



// WEBPACK FOOTER //
// ./src/app/managecards/managecards.ts